import React, { createContext, useState } from 'react'

export const IsMobileContext = createContext(false)

export const IsMobileProvider = ({ children }) => {
    const [isMobileApp, setIsMobileApp] = useState(false)
    const [isAndroid, setIsAndroid] = useState(false)

    return (
        <IsMobileContext.Provider value={{ isMobileApp, setIsMobileApp, isAndroid, setIsAndroid }}>
            {children}
        </IsMobileContext.Provider>
    )
}

export default IsMobileContext
